import { Fund } from '../types';
import { useList } from '@refinedev/core';

type Props = {
  clientId?: string;
};

export const useFunds = (props?: Props) => {
  const { data, isLoading, refetch, error, isError } = useList<Fund>({
    resource: props?.clientId ? `clients/${props.clientId}/funds` : 'funds',
  });

  return {
    funds: data?.data || [],
    isLoading,
    error,
    isError,
    refetch,
  };
};
